class FilterFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);

        const filterForm = this.querySelector('form');
        filterForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

        const filterWrapper = this.querySelector('#FiltersWrapperDesktop');
        if (filterWrapper) filterWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    static setListeners() {
        const onHistoryChange = (event) => {
            const searchParams = event.state ? event.state.searchParams : FilterFiltersForm.searchParamsInitial;
            if (searchParams === FilterFiltersForm.searchParamsPrev) return;
            FilterFiltersForm.renderPage(searchParams, null, false);
        }
        
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActiveFilters(disable = true) {
        document.querySelectorAll('.js-filter-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FilterFiltersForm.searchParamsPrev = searchParams;
        const sections = FilterFiltersForm.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer) {
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop) {
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = element => element.url === url;

            FilterFiltersForm.filterData.some(filterDataUrl) ? FilterFiltersForm.renderSectionFromCache(filterDataUrl, event) : FilterFiltersForm.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FilterFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
        fetch(url)
            .then(response => response.text())
            .then((responseText) => {
                const html = responseText;
                FilterFiltersForm.filterData = [...FilterFiltersForm.filterData, { html, url }];
                FilterFiltersForm.renderFilters(html, event);
                FilterFiltersForm.renderProductGridContainer(html);
                FilterFiltersForm.renderProductCount(html);
            });
    }

    static renderSectionFromCache(filterDataUrl, event) {
        const html = FilterFiltersForm.filterData.find(filterDataUrl).html;
        FilterFiltersForm.renderFilters(html, event);
        FilterFiltersForm.renderProductGridContainer(html);
        FilterFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
    }

    static renderProductCount(html) {
        const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        container.innerHTML = count;
        container.classList.remove('loading');
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const filterDetailsElements =
            parsedHTML.querySelectorAll('#FilterFiltersForm .js-filter, #FilterFiltersFormMobile .js-filter, #FilterFiltersPillsForm .js-filter');
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const filtersToRender = Array.from(filterDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(filterDetailsElements).find(matchesIndex);


        filtersToRender.forEach((element) => {
            document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
        });


        FilterFiltersForm.renderActivefilters(parsedHTML);
        FilterFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) FilterFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    static renderActivefilters(html) {
        const activefilterElementSelectors = ['.active-filters-mobile', '.active-filters-desktop'];

        activefilterElementSelectors.forEach((selector) => {
            const activefiltersElement = html.querySelector(selector);
            if (!activefiltersElement) return;
            document.querySelector(selector).innerHTML = activefiltersElement.innerHTML;
        })

        FilterFiltersForm.toggleActiveFilters(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-filters-open', '.mobile-filters-count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            if (!html.querySelector(selector)) return;
            document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
        });

        document.getElementById('FilterFiltersFormMobile').closest('menu-drawer').bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.filters-selected');
        const sourceElement = source.querySelector('.filters-selected');
        console.log('target:', targetElement, 'source:', sourceElement);
        const targetElementAccessibility = target.querySelector('.filters-summary');
        const sourceElementAccessibility = source.querySelector('.filters-summary');

        if (sourceElement && targetElement) {
            target.querySelector('.filters-selected').outerHTML = source.querySelector('.filters-selected').outerHTML;
        }

        if (targetElementAccessibility && sourceElementAccessibility) {
            target.querySelector('.filters-summary').outerHTML = source.querySelector('.filters-summary').outerHTML;
        }
    }

    static updateURLHash(searchParams) {
        history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
    }

    static getSections() {
        return [
            {
                section: document.getElementById('product-grid').dataset.id,
            }
        ]
    }

    createSearchParams(form) {
        const formData = new FormData(form);
        return new URLSearchParams(formData).toString();
    }

    onSubmitForm(searchParams, event) {
        FilterFiltersForm.renderPage(searchParams, event);
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const sortFilterForms = document.querySelectorAll('filter-filters-form form');
        if (event.srcElement.className == 'mobile-filters-checkbox') {
            const searchParams = this.createSearchParams(event.target.closest('form'))
            this.onSubmitForm(searchParams, event)
        } else {
            const forms = [];
            const isMobile = event.target.closest('form').id === 'filterFiltersFormMobile';

            sortFilterForms.forEach((form) => {
                if (!isMobile) {
                    if (form.id === 'FilterSortForm' || form.id === 'FilterFiltersForm' || form.id === 'filtersortDrawerForm') {
                        forms.push(this.createSearchParams(form));
                    }
                } else if (form.id === 'filterFiltersFormMobile') {
                    forms.push(this.createSearchParams(form));
                }
            });
            this.onSubmitForm(forms.join('&'), event)
        }
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        FilterFiltersForm.toggleActiveFilters();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FilterFiltersForm.renderPage(url);
    }
}

FilterFiltersForm.filterData = [];
FilterFiltersForm.searchParamsInitial = window.location.search.slice(1);
FilterFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('filter-filters-form', FilterFiltersForm);
FilterFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input')
            .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
        this.setMinAndMaxValues();
    }

    onRangeChange(event) {
        this.adjustToValidValues(event.currentTarget);
        this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
        const inputs = this.querySelectorAll('input');
        const minInput = inputs[0];
        const maxInput = inputs[1];
        if (maxInput.value) minInput.setAttribute('max', maxInput.value);
        if (minInput.value) maxInput.setAttribute('min', minInput.value);
        if (minInput.value === '') maxInput.setAttribute('min', 0);
        if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
    }

    adjustToValidValues(input) {
        const value = Number(input.value);
        const min = Number(input.getAttribute('min'));
        const max = Number(input.getAttribute('max'));

        if (value < min) input.value = min;
        if (value > max) input.value = max;
    }
}

customElements.define('price-range', PriceRange);

class filterRemove extends HTMLElement {
    constructor() {
        super();
        const filterLink = this.querySelector('a');
        filterLink.setAttribute('role', 'button');
        filterLink.addEventListener('click', this.closeFilter.bind(this));
        filterLink.addEventListener('keyup', (event) => {
            event.preventDefault();
            if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
        });
    }

    closeFilter(event) {
        event.preventDefault();
        const form = this.closest('filter-filters-form') || document.querySelector('filter-filters-form');
        form.onActiveFilterClick(event);
    }
}

customElements.define('filter-remove', filterRemove);